import MainTable from 'components/common/Tables/MainTable/MainTable';
import React, { forwardRef } from 'react';
import { CustomTableColumnsModal } from 'components/common/Modals/CustomTableColumns/customTableColumnsModal';
import {
    columns,
    initialState,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/relationships/tables/predeccessorsTableWrapper.utils';
import useTableCurrentState from 'hooks/useTableCurrentState';
import { ITableDataItem } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/queries/relationActivityQuery';

interface IPredeccessorsTableWrapperProps {
    data: ITableDataItem[];
    modalColumnsOpen: boolean;
    setModalColumnsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PredeccessorsTableWrapper = forwardRef(
    ({ data, modalColumnsOpen, setModalColumnsOpen }: IPredeccessorsTableWrapperProps, ref: any) => {
        const componentKey = 'predeccessors';
        const updatedInitialState = useTableCurrentState({ initialState, componentKey });

        return (
            <>
                {updatedInitialState && (
                    <MainTable
                        getInstanceCallback={(instance) => (ref.current = instance)}
                        columns={columns}
                        data={data}
                        initialState={updatedInitialState}
                        maxHeight={480}
                    />
                )}
                {ref?.current && (
                    <CustomTableColumnsModal
                        onHideModal={() => setModalColumnsOpen(false)}
                        showModal={modalColumnsOpen}
                        widgetId={undefined}
                        componentKey={componentKey}
                        tableInstance={ref.current}
                        initialState={initialState}
                        columns={columns}
                    />
                )}
            </>
        );
    },
);
